import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeepLinkDefaultLink, getDeepLinkUri } from '../../utils/deepLinkUtils';
import { useNavigate } from 'react-router-dom';

export type SleepingJellyCouponModalType = {
  isSuccess: boolean;
  title: string;
  message: string;
  code: string;
};
type SetModalType = React.Dispatch<React.SetStateAction<boolean>>;
export default function SleepingJellyCouponModal({
  modalInfo,
  setModal,
}: {
  modalInfo: SleepingJellyCouponModalType;
  setModal: SetModalType;
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [deepLinkUri, setDeepLinkUri] = useState(DeepLinkDefaultLink);
  const titleKey = modalInfo.code ? `sleepingJelly.modal.${modalInfo.code}.title` : '';
  const messageKey = modalInfo.code ? `sleepingJelly.modal.${modalInfo.code}.message` : '';
  const hasLocalizedTitle = Boolean(titleKey && i18n.exists(titleKey));
  const apiTitle = modalInfo.title || '';
  const apiMessage = modalInfo.message || '';
  const isLoginApplySuccess =
    apiTitle.includes('앱에서 로그인해 주세요') || apiMessage.includes('정상 적용');
  const daysFromApi = apiMessage.match(/(\d+)일/)?.[1] ?? '21';
  const applyVars = { product: t('sleepingJelly.productName'), days: daysFromApi };

  let title: string;
  let message: string;
  if (hasLocalizedTitle) {
    title = t(titleKey, { limit: 15 });
    message = i18n.exists(messageKey) ? t(messageKey) : '';
  } else if (isLoginApplySuccess) {
    title = t('sleepingJelly.modal.successLoginApply.title');
    message = t('sleepingJelly.modal.successLoginApply.message', applyVars);
  } else {
    title = apiTitle || t('sleepingJelly.modal.fallbackTitle');
    message = apiMessage;
  }

  const onClickButton = () => {
    setModal(false);
    if (!modalInfo.isSuccess) {
      navigate('/jelly/coupon')
    }
  };
  useEffect(() => {
    getDeepLinkUri('jelly').then((url) => {
      setDeepLinkUri(url);
    });
  }, [modalInfo]);
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FFF',
        backgroundColor: '#00000091',
        zIndex: 9999
      }}
    >
      <div style={{ backgroundColor: '#191F28', borderRadius: 20 }}>
        <div
          style={{
            width: 260,
            padding: '36px 30px 20px 30px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <div className="text-[16px] font-bold" style={{ whiteSpace: 'break-spaces' }}>
            {title}
          </div>
          <div className="text-[14px] text-[#D1D6DB]" style={{ whiteSpace: 'break-spaces' }}>
            {message}
          </div>
        </div>
        <div
          style={{
            padding: '10px 24px 20px 24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <button onClick={onClickButton} style={{ borderRadius: 8, background: '#4F68FC', width: '100%', height: 56 }}>
            {modalInfo.isSuccess ? (
              <a className="flex justify-center items-center w-full h-full" href={deepLinkUri}>
                {t('sleepingJelly.modal.openApp')}
              </a>
            ) : (
              t('sleepingJelly.modal.close')
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
